var React = require('react');

function ShapeInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"opacity":"0.1","key":0},React.createElement("path",{"d":"M262.917 92.4735C285.018 131.537 231.484 217.072 171.236 241.888C119.862 263.042 44.7891 243.007 14.1815 179.623C-36.888 73.9049 60.5106 -46.2014 139.026 18.012C202.32 69.776 246.767 58.3294 262.917 92.4735Z","fill":"url(#paint0_linear)"})),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"191.513","y1":"232.037","x2":"68.1707","y2":"3.65399","gradientUnits":"userSpaceOnUse"},[React.createElement("stop",{"offset":"0.25","stopColor":"#08C77D","key":0}),React.createElement("stop",{"offset":"1","stopColor":"#8491A1","key":1})]))]);
}

ShapeInline.defaultProps = {"width":"268","height":"250","viewBox":"0 0 268 250","fill":"none"};

module.exports = ShapeInline;

ShapeInline.default = ShapeInline;
